module.exports = __webpack_public_path__ + "static/media/pray.56242a5b.svg";